export default __webpack_public_path__ + "static/media/campaign-0.089da91f.png";